import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '@/services/TranslationService';
import { changeAndPostProfile } from '../../profile/actions';
import { isApplicationsAction } from '../routeUtils';

const useRouteProfileSync = ({ queryParams, setHeaderTitle }) => {
  const dispatch = useDispatch();
  const [isProfileSyncing, setIsProfileSyncing] = useState(false);
  const [hasProcessedAuthParams, setHasProcessedAuthParams] = useState(false);

  useEffect(() => {
    const title = translate('Route handler') || 'Route handler';
    setHeaderTitle?.(title);

    const shouldSyncProfile =
      !isApplicationsAction(queryParams.action) &&
      (!!queryParams.authority || !!queryParams.country);

    if (!shouldSyncProfile) {
      setHasProcessedAuthParams(true);
      setIsProfileSyncing(false);
      return;
    }

    let isCancelled = false;

    const updateProfile = async () => {
      setHasProcessedAuthParams(false);
      setIsProfileSyncing(true);
      try {
        await dispatch(
          changeAndPostProfile({
            authority: queryParams.authority,
            country: queryParams.country,
          })
        );
      } catch (error) {
        console.error('Failed to update profile from route handler', error);
      } finally {
        if (!isCancelled) {
          setIsProfileSyncing(false);
          setHasProcessedAuthParams(true);
        }
      }
    };

    updateProfile();

    return () => {
      isCancelled = true;
    };
  }, [
    dispatch,
    queryParams.action,
    queryParams.authority,
    queryParams.country,
    setHeaderTitle,
  ]);

  return (
    !isApplicationsAction(queryParams.action) &&
    (!!queryParams.authority || !!queryParams.country) &&
    (!hasProcessedAuthParams || isProfileSyncing)
  );
};

export default useRouteProfileSync;
